(() => {
  const HIDDEN_CLASS = 'utv-thumb-filter-hidden';


  /*
   * Clean up previous listeners if this file
   * gets initialized more than once.
   */
  if (window.utvGalleryChangeHandler) {
    document.removeEventListener(
      'change',
      window.utvGalleryChangeHandler
    );
  }

  if (window.utvGalleryArrowHandler) {
    document.removeEventListener(
      'click',
      window.utvGalleryArrowHandler,
      true
    );
  }

  if (window.utvGalleryKeyHandler) {
    document.removeEventListener(
      'keydown',
      window.utvGalleryKeyHandler,
      true
    );
  }


  /*
   * CSS
   */
  let style = document.getElementById(
    'utv-gallery-filter-style'
  );

  if (!style) {
    style = document.createElement('style');
    style.id = 'utv-gallery-filter-style';
    document.head.appendChild(style);
  }

  style.textContent = `
    .${HIDDEN_CLASS} {
      display: none !important;
    }
  `;


  /*
   * Detect Cover Image marker.
   */
  function parseAlt(alt) {
    if (!alt) {
      return null;
    }

    const parts = alt
      .split('|')
      .map(part => part.trim())
      .filter(Boolean);

    if (!parts.length) {
      return null;
    }

    return {
      isCover:
        parts[
          parts.length - 1
        ].toLowerCase() === 'cover image'
    };
  }


  /*
   * Get current Shopify variant ID from
   * Symmetry's variant-picker JSON.
   */
  function getCurrentVariantId() {
    const json = document.querySelector(
      'variant-picker script[type="application/json"]'
    );

    if (!json) {
      return null;
    }

    try {
      const variant = JSON.parse(
        json.textContent
      );

      return variant?.id
        ? String(variant.id)
        : null;

    } catch (error) {
      console.error(
        'UTV Gallery: variant JSON error',
        error
      );

      return null;
    }
  }


  /*
   * Return current variant's ordered image
   * array if metafield data exists.
   *
   * Otherwise return null and leave Symmetry alone.
   */
  function getCurrentVariantOrder() {
    const data =
      window.utvVariantMediaOrder;

    if (
      !data ||
      typeof data !== 'object' ||
      Array.isArray(data)
    ) {
      return null;
    }

    const variantId =
      getCurrentVariantId();

    if (!variantId) {
      return null;
    }

    if (
      !Object.prototype.hasOwnProperty.call(
        data,
        variantId
      )
    ) {
      return null;
    }

    const order =
      data[variantId];

    if (!Array.isArray(order)) {
      return null;
    }

    return {
      variantId,
      order
    };
  }


  /*
   * Shopify CDN URL -> filename.
   */
  function getFilename(url) {
    if (!url) {
      return '';
    }

    try {
      return new URL(
        url,
        window.location.origin
      )
        .pathname
        .split('/')
        .pop();

    } catch {
      return url
        .split('?')[0]
        .split('/')
        .pop();
    }
  }


  /*
   * Show/reset thumb.
   */
  function showThumb(thumb) {
    thumb.classList.remove(
      HIDDEN_CLASS
    );

    thumb.hidden = false;

    thumb.removeAttribute(
      'hidden'
    );

    thumb.removeAttribute(
      'aria-hidden'
    );

    thumb.style.removeProperty(
      'display'
    );

    thumb.style.removeProperty(
      'visibility'
    );
  }


  /*
   * Hide thumb.
   */
  function hideThumb(thumb) {
    thumb.classList.add(
      HIDDEN_CLASS
    );
  }


  /*
   * Build a global set of every filename
   * assigned to ANY variant.
   *
   * Anything not in this set is considered
   * globally unassigned/general media.
   */
  function getAllAssignedFilenames() {
    const assigned = new Set();

    const data =
      window.utvVariantMediaOrder;

    if (
      !data ||
      typeof data !== 'object' ||
      Array.isArray(data)
    ) {
      return assigned;
    }

    Object.values(data).forEach(
      filenames => {

        if (!Array.isArray(filenames)) {
          return;
        }

        filenames.forEach(
          filename => {

            if (filename) {
              assigned.add(
                String(filename)
              );
            }
          }
        );
      }
    );

    return assigned;
  }


  /*
   * Thumbnail grid.
   */
  function getThumbGrid() {
    return document.querySelector(
      '.media-gallery__inner ' +
      'carousel-slider.thumbnails ' +
      '.slider__grid'
    );
  }


  /*
   * All thumbnail items.
   */
  function getAllThumbs() {
    const grid =
      getThumbGrid();

    if (!grid) {
      return [];
    }

    return Array.from(
      grid.querySelectorAll(
        ':scope > .slider__item'
      )
    );
  }


  /*
   * Visible thumbnail items only.
   */
  function getVisibleThumbs() {
    return getAllThumbs()
      .filter(
        thumb =>
          !thumb.classList.contains(
            HIDDEN_CLASS
          )
      );
  }


  /*
   * Find currently active Symmetry thumbnail.
   */
  function getActiveThumb() {
    const thumbs =
      getAllThumbs();

    let active =
      thumbs.find(
        thumb =>
          thumb.classList.contains(
            'is-active'
          )
      );

    if (active) {
      return active;
    }

    active =
      thumbs.find(thumb => {

        const link =
          thumb.querySelector(
            'a.thumbnail'
          );

        if (!link) {
          return false;
        }

        return (
          link.classList.contains(
            'is-active'
          ) ||
          link.getAttribute(
            'aria-current'
          ) === 'true'
        );
      });

    return active || null;
  }


  /*
   * Activate an existing thumbnail.
   *
   * Symmetry still handles:
   * - main image rendering
   * - active state
   * - transitions
   * - thumbnail scroll
   */
  function activateThumb(thumb) {
    if (!thumb) {
      return;
    }

    const link =
      thumb.querySelector(
        'a.thumbnail'
      );

    if (link) {
      link.click();
    }
  }


  /*
   * First visible thumb.
   */
  function activateFirstVisibleThumb() {
    const visible =
      getVisibleThumbs();

    if (!visible.length) {
      return;
    }

    activateThumb(
      visible[0]
    );
  }


  /*
   * Navigate strictly through visible thumbs.
   */
  function navigateVisible(direction) {
    const visible =
      getVisibleThumbs();

    if (!visible.length) {
      return;
    }

    const active =
      getActiveThumb();

    let currentIndex =
      visible.indexOf(
        active
      );

    if (currentIndex === -1) {

      if (direction === 'previous') {
        currentIndex = 0;

      } else {
        currentIndex = -1;
      }
    }

    let nextIndex;

    if (direction === 'previous') {

      nextIndex =
        currentIndex - 1;

      if (nextIndex < 0) {
        nextIndex =
          visible.length - 1;
      }

    } else {

      nextIndex =
        currentIndex + 1;

      if (
        nextIndex >=
        visible.length
      ) {
        nextIndex = 0;
      }
    }

    activateThumb(
      visible[nextIndex]
    );
  }


  /*
   * Detect Symmetry main-image arrow controls.
   */
  function getArrowDirection(target) {
    const control =
      target.closest(
        '.media-gallery__inner .main-image button, ' +
        '.media-gallery__inner .main-image a'
      );

    if (!control) {
      return null;
    }

    const text = [
      control.getAttribute(
        'aria-label'
      ),
      control.getAttribute(
        'title'
      ),
      control.className,
      control.textContent
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    if (
      text.includes('previous') ||
      text.includes('prev') ||
      text.includes('left')
    ) {
      return 'previous';
    }

    if (
      text.includes('next') ||
      text.includes('right')
    ) {
      return 'next';
    }

    return null;
  }


  /*
   * Leave enlarged/lightbox viewer native.
   */
  function isLightboxOpen() {
    const candidates = [
      '[role="dialog"][open]',
      'dialog[open]',
      '.modal.is-active',
      '.modal.is-open',
      '.lightbox.is-active',
      '.lightbox.is-open',
      '.gallery-viewer.is-active',
      '.gallery-viewer.is-open',
      '.product-media-modal[open]',
      '.product-media-modal.is-active'
    ];

    return candidates.some(
      selector =>
        document.querySelector(
          selector
        )
    );
  }


  /*
   * Main gallery ordering/filtering.
   */
  function updateGallery() {
    const variantData =
      getCurrentVariantOrder();

    /*
     * No metafield/current variant entry:
     * leave Symmetry completely native.
     */
    if (!variantData) {
      return false;
    }

    const {
      variantId,
      order: orderedFilenames
    } = variantData;

    const grid =
      getThumbGrid();

    if (!grid) {
      return false;
    }

    const currentAssigned =
      new Set(
        orderedFilenames.map(
          filename =>
            String(filename)
        )
      );

    const allAssigned =
      getAllAssignedFilenames();

    const thumbs =
      getAllThumbs();

    /*
     * Preserve native Shopify order
     * for globally unassigned images.
     */
    const naturalOrder =
      [...thumbs];

    /*
     * filename -> thumb node
     */
    const byFilename =
      new Map();

    thumbs.forEach(
      thumb => {

        const img =
          thumb.querySelector(
            'img'
          );

        if (!img) {
          return;
        }

        const filename =
          getFilename(
            img.currentSrc ||
            img.src
          );

        if (filename) {
          byFilename.set(
            filename,
            thumb
          );
        }
      }
    );


    /*
     * Reset all thumbnails first.
     */
    thumbs.forEach(
      showThumb
    );


    /*
     * STEP 1
     *
     * Current variant images first,
     * exact PIM/metafield order.
     *
     * This includes the Cover Image
     * if it was explicitly assigned
     * to this variant.
     */
    orderedFilenames.forEach(
      filename => {

        const thumb =
          byFilename.get(
            String(filename)
          );

        if (thumb) {
          grid.appendChild(
            thumb
          );
        }
      }
    );


    /*
     * STEP 2
     *
     * Globally unassigned/general images
     * next, preserving Shopify order.
     */
    naturalOrder.forEach(
      thumb => {

        const img =
          thumb.querySelector(
            'img'
          );

        if (!img) {
          return;
        }

        const filename =
          getFilename(
            img.currentSrc ||
            img.src
          );

        if (
          filename &&
          !allAssigned.has(
            filename
          )
        ) {
          grid.appendChild(
            thumb
          );
        }
      }
    );


    /*
     * STEP 3
     *
     * Other-variant images go last.
     * They will be hidden.
     */
    naturalOrder.forEach(
      thumb => {

        const img =
          thumb.querySelector(
            'img'
          );

        if (!img) {
          return;
        }

        const filename =
          getFilename(
            img.currentSrc ||
            img.src
          );

        if (
          filename &&
          allAssigned.has(
            filename
          ) &&
          !currentAssigned.has(
            filename
          )
        ) {
          grid.appendChild(
            thumb
          );
        }
      }
    );


    /*
     * STEP 4
     *
     * Visibility.
     *
     * PRIORITY IS IMPORTANT:
     *
     * 1. Assigned to current variant -> SHOW
     * 2. Cover but not assigned here -> HIDE
     * 3. Globally unassigned -> SHOW
     * 4. Other variant -> HIDE
     */
    getAllThumbs().forEach(
      thumb => {

        const img =
          thumb.querySelector(
            'img'
          );

        if (!img) {
          showThumb(
            thumb
          );

          return;
        }

        const filename =
          getFilename(
            img.currentSrc ||
            img.src
          );

        const altData =
          parseAlt(
            img.alt
          );


        /*
         * RULE 1
         *
         * Assigned to CURRENT variant.
         *
         * This wins even if the image
         * also has | Cover Image.
         */
        if (
          filename &&
          currentAssigned.has(
            filename
          )
        ) {
          showThumb(
            thumb
          );

          return;
        }


        /*
         * RULE 2
         *
         * Cover Image that is NOT assigned
         * to current variant stays hidden
         * on the PDP thumbnail strip.
         *
         * This does NOT affect Shopify's
         * collection/search featured image.
         */
        if (
          altData?.isCover
        ) {
          hideThumb(
            thumb
          );

          return;
        }


        /*
         * RULE 3
         *
         * Globally unassigned/general image.
         */
        if (
          filename &&
          !allAssigned.has(
            filename
          )
        ) {
          showThumb(
            thumb
          );

          return;
        }


        /*
         * RULE 4
         *
         * Assigned only to another variant.
         */
        hideThumb(
          thumb
        );
      }
    );


    console.log(
      'UTV Gallery updated:',
      variantId,
      orderedFilenames
    );

    return true;
  }


  /*
   * Symmetry does some variant work
   * after the input change.
   */
  function scheduleUpdate(
    activateFirst = false
  ) {
    setTimeout(
      updateGallery,
      50
    );

    setTimeout(
      updateGallery,
      150
    );

    setTimeout(
      updateGallery,
      350
    );

    setTimeout(
      () => {

        const handled =
          updateGallery();

        if (
          activateFirst &&
          handled
        ) {
          setTimeout(
            activateFirstVisibleThumb,
            50
          );
        }

      },
      700
    );
  }


  /*
   * Variant option changes.
   */
  window.utvGalleryChangeHandler =
    event => {

      if (
        event.target.matches(
          'variant-picker input.js-option'
        )
      ) {
        scheduleUpdate(
          true
        );
      }
    };

  document.addEventListener(
    'change',
    window.utvGalleryChangeHandler
  );


  /*
   * PDP MOUSE ARROWS
   */
  window.utvGalleryArrowHandler =
    event => {

      if (isLightboxOpen()) {
        return;
      }

      const direction =
        getArrowDirection(
          event.target
        );

      if (!direction) {
        return;
      }

      if (!getCurrentVariantOrder()) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      navigateVisible(
        direction
      );
    };

  document.addEventListener(
    'click',
    window.utvGalleryArrowHandler,
    true
  );


  /*
   * PDP KEYBOARD ARROWS
   */
  window.utvGalleryKeyHandler =
    event => {

      if (
        event.key !== 'ArrowLeft' &&
        event.key !== 'ArrowRight'
      ) {
        return;
      }

      if (isLightboxOpen()) {
        return;
      }

      if (
        event.target.matches(
          'input, textarea, select, option'
        )
      ) {
        return;
      }

      if (!getCurrentVariantOrder()) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      navigateVisible(
        event.key === 'ArrowLeft'
          ? 'previous'
          : 'next'
      );
    };

  document.addEventListener(
    'keydown',
    window.utvGalleryKeyHandler,
    true
  );


  /*
   * Debug/manual controls.
   */
  window.utvUpdateGallery =
    updateGallery;

  window.utvActivateFirstImage =
    activateFirstVisibleThumb;

  window.utvNextImage =
    () =>
      navigateVisible(
        'next'
      );

  window.utvPreviousImage =
    () =>
      navigateVisible(
        'previous'
      );


  /*
   * Initial page load.
   */
  function initialize() {
    scheduleUpdate(
      false
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );

  } else {
    initialize();
  }

})();

/*
 * Main photo follows the thumbnail strip, plus a "1 / 6" counter (2026-10-14).
 *
 * The filter above hides other variants' photos in the thumbnail strip only.
 * The swipeable main photo (what phones use) still held every photo, so a swipe
 * ran through other colors too. This copies the strip onto the main slides: same
 * order, same hidden ones, then refreshes the carousel. That is the same
 * hide-and-refresh Symmetry's own media grouping does (slider.js only counts
 * slides that aren't [hidden]). It also keeps a counter on the main photo,
 * shown on phones by assets/utvdude-custom.css. Plan:
 * docs/systems/product-page-design.md in the PIM.
 */
(() => {
  const HIDDEN_CLASS = 'utv-thumb-filter-hidden';

  if (window.utvMainSyncObserver) {
    window.utvMainSyncObserver.disconnect();
  }
  if (window.utvCounterHandler) {
    document.removeEventListener('on:media-gallery:change', window.utvCounterHandler);
  }

  function getGallery() {
    return document.querySelector('.media-gallery');
  }

  function getMainGrid() {
    const gallery = getGallery();
    return gallery ? gallery.querySelector('.main-image carousel-slider .slider__grid') : null;
  }

  function getThumbs() {
    const gallery = getGallery();
    return gallery
      ? Array.from(gallery.querySelectorAll('carousel-slider.thumbnails .slider__grid > .slider__item'))
      : [];
  }

  function signature(slides) {
    return slides.map(slide => slide.dataset.mediaId + (slide.hidden ? 'h' : '')).join(',');
  }

  function syncMainToThumbs() {
    try {
      const grid = getMainGrid();
      const thumbs = getThumbs();
      if (!grid || !thumbs.length) return;

      const current = Array.from(grid.querySelectorAll(':scope > .slider__item'));
      const byId = new Map(current.map(slide => [slide.dataset.mediaId, slide]));

      // Wanted: strip order; hidden ones moved to the end, as Symmetry does.
      const wanted = [];
      const hiddenIds = new Set();
      thumbs.forEach(thumb => {
        const slide = byId.get(thumb.dataset.mediaId);
        if (!slide) return;
        wanted.push(slide);
        if (thumb.classList.contains(HIDDEN_CLASS)) hiddenIds.add(thumb.dataset.mediaId);
      });
      current.forEach(slide => { if (!wanted.includes(slide)) wanted.push(slide); });
      const ordered = wanted.filter(s => !hiddenIds.has(s.dataset.mediaId))
        .concat(wanted.filter(s => hiddenIds.has(s.dataset.mediaId)));

      const wantedSig = ordered.map(s => s.dataset.mediaId + (hiddenIds.has(s.dataset.mediaId) ? 'h' : '')).join(',');
      if (wantedSig === signature(current)) return;

      ordered.forEach(slide => {
        slide.hidden = hiddenIds.has(slide.dataset.mediaId);
        grid.appendChild(slide);
      });

      const slider = grid.closest('carousel-slider');
      if (slider && slider.offsetParent && typeof slider.refresh === 'function') {
        slider.refresh();
        const active = grid.querySelector(':scope > .slider__item.is-active:not([hidden])')
          || grid.querySelector(':scope > .slider__item:not([hidden])');
        if (active && typeof slider.scrollToElement === 'function') {
          slider.scrollToElement(active, 'instant');
        }
      }
    } catch (error) {
      console.error('UTV Gallery: main photo sync error', error);
    }
  }

  function updateCounter() {
    try {
      const grid = getMainGrid();
      if (!grid) return;
      const main = grid.closest('.main-image');
      const visible = Array.from(grid.querySelectorAll(':scope > .slider__item:not([hidden])'));
      let counter = main.querySelector('.ud-gallery-count');

      if (visible.length < 2) {
        if (counter) counter.remove();
        return;
      }
      if (!counter) {
        counter = document.createElement('span');
        counter.className = 'ud-gallery-count';
        counter.setAttribute('aria-hidden', 'true');
        main.appendChild(counter);
      }
      const index = visible.findIndex(slide => slide.classList.contains('is-active'));
      const text = `${index < 0 ? 1 : index + 1} / ${visible.length}`;
      // Only write when it changes: the observer below watches this subtree.
      if (counter.textContent !== text) counter.textContent = text;
    } catch (error) {
      console.error('UTV Gallery: counter error', error);
    }
  }

  let timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      syncMainToThumbs();
      updateCounter();
    }, 30);
  }

  function start() {
    const gallery = getGallery();
    if (!gallery) return;

    // The strip changes when the filter runs (classes, order); the main slides
    // change when a photo is swiped to (is-active). Both re-run sync + counter;
    // sync does nothing when the main slides already match.
    window.utvMainSyncObserver = new MutationObserver(schedule);
    window.utvMainSyncObserver.observe(gallery, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'hidden']
    });

    window.utvCounterHandler = schedule;
    document.addEventListener('on:media-gallery:change', window.utvCounterHandler);

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
